
import {
    UPDATE_STORE_ID_CHECKOUT,
    UPDATE_API_TOKEN_CHECKOUT,
    UPDATE_CHECKOUT_ID_CHECKOUT,
    CHECKOUT_PRELOAD_REQUEST_SENT,
    CHECKOUT_PRELOAD_REQUEST_SUCCESS,
    CHECKOUT_PRELOAD_REQUEST_FAIL,
    SELECT_LEFT_SAMPLE_SHOW,
    SELECT_RIGHT_SAMPLE_SHOW,
    SELECT_IF_DISPLAY_IFRAME,
    CHECKOUT_RECEIPT_SENT,
    CHECKOUT_RECEIPT_SUCCESS,
    CHECKOUT_RECEIPT_FAIL,
    UPDATE_TICKET_CHECKOUT,
    SELECT_NOT_DISPLAY_IFRAME,
    SET_TERMINATE_CHECKOUT,
    SET_NOT_TERMINATE_CHECKOUT,
    SET_DISPLAY_CHECKOUT,
    SET_NOT_DISPLAY_CHECKOUT,
    UPDATE_CALLBACK_CONSOLE,
    SET_SHOW_CALLBACK_CONSOLE,
    SET_NOT_SHOW_CALLBACK_CONSOLE,
    SET_PRELOAD_REQEUST_MESSAGE,
    UPDATE_TXN_TOTAL,
    UPDATDE_FIRST_FIELD,
    UPDATDE_SECOND_FIELD,
    UPDATDE_THIRD_FIELD,
    SELECT_MODE_CHECKOUT,
    OPEN_ALL_TABLES,
    _MCO,
    RESET_CONFIGURATION,
} from '../../actions/types'


const initialState = {
    storeId: "store2",
    apiToken: "yesguy",
    checkoutId: "chktXZACHtore2",
    txnTotal: "2.00",
    PreoloadPrequestMessage: `{
 "store_id":"store2",
 "api_token": "yesguy",
 "checkout_id":"chktXZACHtore2",
 "txn_total":"2.00",
 "environment":"qa",
 "action":"preload"
}`,
    PreoloadPrequestResponse: "waiting for preload request(pressing the button on the left)",
    receipt: "waiting for receipt request(pressing the button on the left)",
    ticket: "",
    ifLeftShow: true,
    ifDisplayIframe: false,
    ifTerminateCheckout: false,
    ifDisplayCheckout: false,
    ifShowCallbackConsole: false,
    callBackConsole: ["No CallBack Yet"],
    isFirstShow:true,
    isSecondShow:false,
    isThirdShow:false,
    mode: 'integration_guide',
    isAllTableOpen:false
}

// eslint-disable-next-line
export default function (state = initialState, action) {
    if(action.feature === _MCO) {
        switch (action.type) {
            case OPEN_ALL_TABLES:
                return { ...state, isAllTableOpen: action.payload }

            case SELECT_MODE_CHECKOUT:
                return { ...state, mode: action.payload }

            case UPDATDE_FIRST_FIELD:
                return {...state, isFirstShow:action.payload}

            case UPDATDE_SECOND_FIELD:
                return {...state, isSecondShow:action.payload}   

            case UPDATDE_THIRD_FIELD:
                return {...state, isThirdShow:action.payload}    

            case SET_PRELOAD_REQEUST_MESSAGE:
                return { ...state, PreoloadPrequestMessage: action.payload }

            case SET_SHOW_CALLBACK_CONSOLE:
                return { ...state, ifShowCallbackConsole: true }

            case SET_NOT_SHOW_CALLBACK_CONSOLE:
                return { ...state, ifShowCallbackConsole: false }


            case UPDATE_CALLBACK_CONSOLE:
                let acc = []
                if (action.payload === "empty") {
                    return { ...state, callBackConsole: ["No CallBack Yet"] }
                } else {
                    if (state.callBackConsole[0] === "No CallBack Yet") {
                        acc.push(action.payload)
                    } else {
                        acc = [...state.callBackConsole]
                        acc.push(action.payload)
                    }
                    return { ...state, callBackConsole: acc }
                }

            case SET_TERMINATE_CHECKOUT:
                return { ...state, ifTerminateCheckout: true }

            case SET_NOT_TERMINATE_CHECKOUT:
                return { ...state, ifTerminateCheckout: false }



            case SET_DISPLAY_CHECKOUT:
                return { ...state, ifDisplayCheckout: true }

            case SET_NOT_DISPLAY_CHECKOUT:
                return { ...state, ifDisplayCheckout: false }



            case UPDATE_TICKET_CHECKOUT:
                return { ...state, ticket: action.payload }
            case CHECKOUT_RECEIPT_SENT:
                return { ...state, receipt: "" }
            case CHECKOUT_RECEIPT_SUCCESS:
                return { ...state, receipt: action.payload }
            case CHECKOUT_RECEIPT_FAIL:
                return { ...state, receipt: action.payload }




            case SELECT_NOT_DISPLAY_IFRAME:
                return { ...state, ifDisplayIframe: false }
            case SELECT_IF_DISPLAY_IFRAME:
                return { ...state, ifDisplayIframe: true }


            case SELECT_RIGHT_SAMPLE_SHOW:
                return { ...state, ifLeftShow: false }
            case SELECT_LEFT_SAMPLE_SHOW:
                return { ...state, ifLeftShow: true }


            case CHECKOUT_PRELOAD_REQUEST_SENT:
                return { ...state, PreoloadPrequestResponse: "" }
            case CHECKOUT_PRELOAD_REQUEST_SUCCESS:
                return { ...state, PreoloadPrequestResponse: action.payload }
            case CHECKOUT_PRELOAD_REQUEST_FAIL:
                return { ...state, PreoloadPrequestResponse: action.payload }


            case UPDATE_STORE_ID_CHECKOUT:
                let preloadMessageStoreId = `{
    "store_id":"${action.payload}",
    "api_token":"${state.apiToken}",
    "checkout_id":"${state.checkoutId}",
    "txn_total":"${state.txnTotal}",
    "environment":"qa",
    "action":"preload"
}`
                return { ...state, storeId: action.payload, PreoloadPrequestMessage: preloadMessageStoreId }
            case UPDATE_API_TOKEN_CHECKOUT:
                let preloadMessageApi = `{
    "store_id":"${state.storeId}",
    "api_token":"${action.payload}",
    "checkout_id":"${state.checkoutId}",
    "txn_total":"${state.txnTotal}",
    "environment":"qa",
    "action":"preload"
}`
                return { ...state, apiToken: action.payload, PreoloadPrequestMessage: preloadMessageApi }
            
            case UPDATE_CHECKOUT_ID_CHECKOUT:
                let preloadMessageCheckouId = `{
    "store_id":"${state.storeId}",
    "api_token":""${state.apiToken}",
    "checkout_id":"${action.payload}",
    "txn_total":"${state.txnTotal}",
    "environment":"qa",
    "action":"preload"
}`
                return { ...state, checkoutId: action.payload, PreoloadPrequestMessage: preloadMessageCheckouId }



            case UPDATE_TXN_TOTAL:
                let preloadMessageTxnTotal = `{
    "store_id":"${state.storeId}",
    "api_token":""${state.apiToken}",
    "checkout_id":"${state.checkoutId}",
    "txn_total":"${action.payload}",
    "environment":"qa",
    "action":"preload"
}`
                return { ...state, txnTotal: action.payload.toString(), PreoloadPrequestMessage: preloadMessageTxnTotal }
            
            case RESET_CONFIGURATION:
                return { ...state, apiToken: initialState.apiToken, storeId: initialState.storeId, checkoutId: initialState.checkoutId, txnTotal: initialState.txnTotal }

            default:
                return state
        }
    }
    else {
        return state
    }
}